import { render, staticRenderFns } from "./CreateGoogleAccount.vue?vue&type=template&id=3dc8f84c&scoped=true"
import script from "./CreateGoogleAccount.vue?vue&type=script&lang=js"
export * from "./CreateGoogleAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateGoogleAccount.vue?vue&type=style&index=0&id=3dc8f84c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc8f84c",
  null
  
)

export default component.exports